import { gsap } from 'gsap'
import { useCallback, useEffect, useRef, useState } from 'react'

const useCollapsible = (ref, isExpanded, duration = 0.4) => {
  const [isVisible, setIsVisible] = useState(isExpanded)
  const wasExpanded = useRef(isExpanded)

  /**
   * Expand the display
   */
  const expand = useCallback(() => {
    gsap.killTweensOf(ref.current)

    setIsVisible(true)

    ref.current.style.display = 'block'

    gsap.to(ref.current, {
      height: 'auto',
      duration
    })
  }, [])

  /**
   * Collapse the display
   */
  const collapse = useCallback(() => {
    gsap.killTweensOf(ref.current)

    gsap.to(ref.current, {
      height: 0,
      duration,
      onComplete: () => {
        ref.current.style.display = 'none'
        setIsVisible(false)
      }
    })
  }, [])

  /**
   * Effect: When the `isExpanded` state changes
   */
  useEffect(() => {
    if (isExpanded === wasExpanded.current) {
      return
    }

    wasExpanded.current = isExpanded

    if (isExpanded) {
      expand()

      return
    }

    collapse()
  }, [isExpanded])

  /**
   * Effect: On mount/unmount
   */
  useEffect(() => {
    wasExpanded.current = isExpanded

    if (!isExpanded) {
      gsap.set(ref.current, { height: 0 })
      ref.current.style.display = 'none'
    }

    return () => {
      if (ref.current) {
        gsap.killTweensOf(ref.current)
      }
    }
  }, [])

  return isVisible
}

// Export
export default useCollapsible
